module.exports = __webpack_public_path__ + "static/media/TTF.ead2928e.png";